export function snakeCase(value: string): string {
  return value
    .trim()
    // Separate camelCase / PascalCase
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    // Replace anything except letters/numbers (including Persian) with spaces
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
}